import React from "react"
import { Link, graphql } from "gatsby"
import './reflexicon.css';

import Layout from "../components/reflexicon/layout"
import { HomeFooter } from "../components/reflexicon/footer";
import { HomeHeader } from "../components/reflexicon/header";


const ReflexiconIndexPage = ({ data }) => {
  const { modes } = data.config;
  return (
    <Layout model="home" footer={<HomeFooter />} header={<HomeHeader />}>
      <div className="ReflexiconIndex">
        <div className="ReflexiconIndex_Desc">
          <div><strong>DESIGNING WITH FUTURE TERMS</strong><br />REFLEXICON is a game that invites you to play with future terms from the Lexicon of the Future Education and Literacy for Designers project.</div>
          <div>The REFLEXICON will help you apply the terms to your design project or activity as a designer to understand how your work might relate to shaping future needs, conditions and challenges.</div>
        </div>
        <div className="ReflexiconIndex_NavModeLabel">SELECT A GAME MODE TO START:</div>
        <ul className="ReflexiconIndex__NavMode">
          {modes.map((o, k) => (
            <li key={k} className={"NavModeItem"+(o.layout?` NavModeItem_${o.layout}`:'')} style={{
              borderColor: o.color,
              color: o.color
            }}>
              {o.icon && data[o.icon] && <div className="NavModeItem__Icon">
                  <img src={data[o.icon].publicURL} alt={o.icon} />
              </div>}
              <div className="NavModeItem__Content">
                <h2 className="NavModeItem__Title">{o.name}</h2>
                <p className="NavModeItem__Desc">{o.desc}</p>
              </div>
              <Link to={`/reflexicon/mode/${o.slug}`} className="NavModeItem__Button" style={{
                backgroundColor: o.color
              }}>Start!</Link>
            </li>
          ))}

        </ul>
        <div className="CTA">After you experience with the REFLEXICON, please take our survey  to help us in improving our tool: <a className="button" target="_blank" rel="noopener noreferrer"  href="http://reflexicon.design-friction.com">SHARE YOUR FEEDBACK!</a></div>
      </div>
    </Layout>
  )
}

export default ReflexiconIndexPage

export const pageQuery = graphql`
  query IndexQuery {
    config:allReflexiconYaml(sort: {order: ASC, fields: order}) {
      modes:nodes {
        color
        layout
        icon
        desc
        name
        slug
      }
    }
    reflexicovidicon:file(base: {eq: "reflexicovidicon.svg"}) {
      base
      publicURL
    }
  }
`;
